import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

const API_URL = process.env.REACT_APP_BACKEND_URL;

const AuthCallback = () => {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const params = new URLSearchParams(hash.replace("#", "?"));
    const sessionId = params.get("session_id");

    if (!sessionId) {
      navigate("/auth", { replace: true });
      return;
    }

    (async () => {
      try {
        const res = await fetch(`${API_URL}/api/auth/google/session`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify({ session_id: sessionId }),
        });

        if (!res.ok) {
          navigate("/auth", { replace: true });
          return;
        }

        const data = await res.json();

        // Store JWT for the existing auth system (AuthContext reads from localStorage)
        if (data.access_token) {
          localStorage.setItem("prana_token", data.access_token);
          localStorage.setItem("prana_token_timestamp", Date.now().toString());
        }

        // Reload to let AuthContext pick up the token and load user
        const dest = data.user?.is_new_user ? "/onboarding" : "/dashboard";
        window.location.replace(dest);
      } catch {
        navigate("/auth", { replace: true });
      }
    })();
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center page-background" data-testid="auth-callback">
      <div className="text-center">
        <div className="w-8 h-8 border-2 border-[var(--primary)] border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="text-[var(--text-secondary)] text-sm">Signing you in...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
